<!-- Back-to-top -->
<div
  class="scrollToTop"
  (click)="taptotop()"
  [ngStyle]="{ display: show ? 'block' : 'none' }"
  style="display: flex; align-items: center;"
>
  <span class="arrow"><i class="bi bi-chevron-double-up"></i></span>
</div>
